<template>
    <div class="sub-navigation">
        <!-- Desktop navigation -->
        <b-navbar class="is-hidden-touch">
            <template #start>
                <component
                    :is="item.children ? 'DropdownNavigationItem' : 'DefaultNavigationItem'"
                    v-for="item in navigation"
                    :key="item.name"
                    :item="item"
                />

                <slot name="desktop"></slot>
            </template>
        </b-navbar>

        <!-- Tablet/Mobile navigation -->
        <aside class="menu is-hidden-desktop">
            <ul class="menu-list">
                <li
                    v-for="item in navigation"
                    :key="item.name"
                >
                    <router-link
                        v-if="item.visible"
                        class="navbar-item"
                        exact-path
                        active-class="is-active"
                        :to="{ name: item.name }"
                    >
                        {{ item.label }}
                    </router-link>

                    <ChildNavigation :item="item" />
                </li>

                <slot name="mobile"></slot>
            </ul>
        </aside>
    </div>
</template>

<script>
import DropdownNavigationItem from './DropdownNavigationItem';
import DefaultNavigationItem from './DefaultNavigationItem';
import ChildNavigation from './ChildNavigation';

export default {
    components: {
        DropdownNavigationItem,
        DefaultNavigationItem,
        ChildNavigation,
    },

    props: {
        navigation: {
            type: Array,
            default: () => [],
        },
    },
};
</script>
